import axios from "axios";
import { DataGrid, Button } from "devextreme-react";
import {
  // TreeList,
  Column,
  ColumnChooser,
  GroupItem,
  HeaderFilter,
  Item,
  LoadPanel,
  Pager,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  StateStoring,
  Summary,
  Toolbar,
} from "devextreme-react/data-grid";
import { Workbook } from "exceljs";
import React, { useEffect, useRef, useState } from "react";
import HospURL from "./HospURL";

import jsPDF from "jspdf";
import "jspdf-autotable";
import { malgun } from "../malgun";
import { Export } from "devextreme-react/data-grid";

// import { exportDataGrid } from "devextreme/excel_exporter";
// import { exportDataGrid as exportDataGridToPDF } from "devextreme/pdf_exporter";
// import { saveAs } from "file-saver-es";

export default function SiteNInvestigator(props) {
  const { indication } = props;
  const [dataSource, setDataSource] = useState(null);

  const treeListRef = useRef(null);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/clinicTestOprtnInsttInfoService01/byInvestigator?indication=${indication}`
      )
      .then((result) => {
        setDataSource(result.data);
      });
  }, [indication]);

  // const onExporting = (e) => {
  //   const workbook = new Workbook();
  //   const worksheet = workbook.addWorksheet("의약품임상시험 실시기관 정보");

  //   exportDataGrid({
  //     component: e.component,
  //     worksheet,
  //     autoFilterEnabled: true,
  //   }).then(() => {
  //     workbook.xlsx.writeBuffer().then((buffer) => {
  //       saveAs(
  //         new Blob([buffer], {
  //           type: "application/octet-stream",
  //         }),
  //         "식품의약품안전처_의약품임상시험 실시기관 정보.xlsx"
  //       );
  //     });
  //   });

  //   e.cancel = true;
  // };

  // const exportGrid = React.useCallback(() => {
  //   const doc = new jsPDF("l", "mm", [297, 210]);

  //   doc.addFileToVFS("malgun.ttf", malgun);
  //   doc.addFont("malgun.ttf", "malgun", "normal");
  //   doc.setFont("malgun");

  //   // const dataGrid = dataGridRef.current.instance;
  //   const treeList = treeListRef.current.instance;

  //   exportDataGridToPDF({
  //     jsPDFDocument: doc,
  //     // component: dataGrid,
  //     component: treeList,
  //     autoTableOptions: {
  //       styles: {
  //         font: "malgun",
  //       },
  //     },
  //   }).then(() => {
  //     doc.save("식품의약품안전처_의약품 임상시험 정보.pdf");
  //   });
  // });

  const linkClinicalTrialsGov = React.useCallback(() => {
    window.open(`https://clinicaltrials.gov`);
  });

  // const handleExportClick = () => {
  //   if (treeListRef.current) {
  //     exportToExcel(treeListRef.current.instance);
  //   }
  // };

  const customizeText = (cellInfo) => {
    return cellInfo.value == 0 ? `` : cellInfo.valueText;
  };

  return (
    <DataGrid
      dataSource={dataSource}
      showBorders={true}
      showColumnLines={true}
      // columnAutoWidth={true}
      wordWrapEnabled={true}
      keyExpr="INVESTIGATOR_KEY"
      // parentIdExpr="LAB_NAME"
      id="lab_investigator"
      ref={treeListRef}
      focusedRowEnabled={true}
      rowAlternationEnabled={true}
      // onExporting={onExporting}
      allowColumnResizing={true}
    >
      <SearchPanel visible={true} highlightCaseSensitive={true} />
      <HeaderFilter visible={true} />
      {/* <FilterRow visible={true} /> */}
      <Selection mode={"single"} />
      <ColumnChooser enabled={true} />
      <LoadPanel enabled={true} />

      <Scrolling mode="standard" showScrollbar="always" />
      <Paging enabled={true} defaultPageSize={10} />
      <Pager
        visible={true}
        showPageSizeSelector={true}
        allowedPageSizes={[5, 10, 20]}
        showInfo={true}
      />

      <StateStoring
        enabled={true}
        type="localStorage"
        storageKey={"openAPI.Indication.SiteNInvestigator.v2"}
      />

      <Export enabled={true} />

      <Column
        dataField="LAB_NAME"
        caption="실시기관명"
        dataType="string"
        width={250}
        // cellRender={HospURL}
        fixed={true}
        groupIndex={0}
      />
      <Column
        dataField="CANONICAL_NAME"
        caption="책임자명"
        dataType="string"
        width={140}
        // cellRender={HospURL}
        fixed={true}
      />
      <Column
        dataField="RESP_RESRC_OFTL"
        caption="소속·직함"
        dataType="string"
        width={280}
      />
      <Column
        dataField="SOURCE_INSPCT_MANAGER_NAMES_DISPLAY"
        caption="원문 책임자명"
        dataType="string"
        visible={false}
        allowSearch={true}
      />
      <Column
        dataField="SOLE_COUNT"
        caption="단독"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="JOINT_COUNT"
        caption="공동"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField={"TOTAL"}
        caption="Total"
        dataType={"number"}
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="0상"
        caption="0상"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="1/2상"
        caption="1/2상"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="1/2a상"
        caption="1/2a상"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="1/3상"
        caption="1/3상"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="1상"
        caption="1상"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="1b상"
        caption="1b상"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="2/3상"
        caption="2/3상"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="2상"
        caption="2상"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="2a상"
        caption="2a상"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="2b/3상"
        caption="2b/3상"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="2b상"
        caption="2b상"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="3/4상"
        caption="3/4상"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="3상"
        caption="3상"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="3a상"
        caption="3a상"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="3b상"
        caption="3b상"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="4상"
        caption="4상"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="생동"
        caption="생동"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="연구자 임상시험"
        caption="연구자 임상시험"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column
        dataField="연장"
        caption="연장"
        dataType="number"
        allowFiltering={false}
        allowHeaderFiltering={false}
      />
      <Column caption="Hosp." cellRender={HospURL} width={70} />

      <Summary>
        <GroupItem
          column={"TOTAL"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"0상"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"1/2상"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"1/2a상"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"1/3상"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"1상"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"1b상"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"2/3상"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"2상"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"2a상"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"2b/3상"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"2b상"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"3/4상"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"3상"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"3a상"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"3b상"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"4상"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"생동"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"연구자 임상시험"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
        <GroupItem
          column={"연장"}
          summaryType={"sum"}
          alignByColumn={true}
          displayFormat={"{0}"}
        />
      </Summary>

      <Toolbar>
        {/* <Item location="after">
          <Button icon="blind.png" onClick={handleBlind} />
        </Item> */}
        <Item location="after">
          <Button
            // icon="https://clinicaltrials.gov/ct2/html/images/favicon.ico"
            icon="https://clinicaltrials.gov/assets/favicons/favicon.svg" //
            // text="ClinicalTrials.gov"
            onClick={linkClinicalTrialsGov}
          />
        </Item>
        {/* <Item
          location={"after"}
          widget={"dxButton"}
          options={{
            text: "Export to Excel",
            icon: "exportxlsx",
            onClick: handleExportClick,
          }}
        /> */}
        {/* <Item location="after">
          <Button icon="exportpdf" onClick={exportGrid} />
        </Item> */}
        <Item location={"after"} name="exportButton" />
        <Item name="columnChooserButton" />
        <Item name="searchPanel" />
      </Toolbar>
    </DataGrid>
  );
}
